export default "__VITE_ASSET__BnHDz_YB__"